export const GET_LEADSOURCES = "GET_LEADSOURCES";
export const ADD_LEADSOURCE = "ADD_LEADSOURCE";
export const EDIT_LEADSOURCE = "EDIT_LEADSOURCE";
export const GET_LEADSOURCE = "GET_LEADSOURCE";
export const RESET_LEADSOURCE = "RESET_LEADSOURCE";
export const ERROR_LEADSOURCE = "ERROR_LEADSOURCE";
export const GET_ALL_LEADSOURCES = "GET_ALL_LEADSOURCES";
                    